import { AppDispatch } from "store/store";
import { httpWrapper } from "../../utils/http";
import { SMS_API_BASE } from "../../constants";
import { handleError } from "errors/errors";
import {
  updateCustomLogoSettingStart,
  updateCustomLogoSettingSuccess,
  updateCustomLogoSettingError,
  getCustomLogoSettingStart,
  getCustomLogoSettingSuccess,
  getCustomLogoSettingError,
} from "./ClientCustomLogoSettingsSlice";
import {
  Client,
  CustomLogoUpdateForm,
  LogoUploadResult,
} from "../../api/sms-api";
import i18n from "i18n";
import { showNotification } from "utils/notifications";

const uploadLogo = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return httpWrapper<LogoUploadResult>(
    "POST",
    `${SMS_API_BASE}/client/logo`,
    formData,
    { "Content-Type": "multipart/form-data" }
  );
};

export const updateCustomLogoSetting = (
  params: CustomLogoUpdateForm,
  file: File | null
) => async (dispatch: AppDispatch) => {
  dispatch(updateCustomLogoSettingStart());
  try {
    // First upload the logo if it exists
    if (file) {
      const result = await uploadLogo(file);
      // Then get the logo url
      if (result) {
        params.customLogoUrl = result.url;
      }
    }
    // Then update the rest
    const updated = await httpWrapper<Client>(
      "PATCH",
      `${SMS_API_BASE}/client/update_custom_logo`,
      params
    );

    showNotification(i18n.t("client.editSuccess"));
    dispatch(updateCustomLogoSettingSuccess(updated));
  } catch (e) {
    handleError(e);
    dispatch(updateCustomLogoSettingError(e));
  }
};

export const getCustomLogoSetting = () => async (dispatch: AppDispatch) => {
  dispatch(getCustomLogoSettingStart());
  try {
    const client = await httpWrapper<Client>(
      "GET",
      `${SMS_API_BASE}/client`,
      {}
    );
    dispatch(getCustomLogoSettingSuccess(client));
  } catch (e) {
    handleError(e);
    dispatch(getCustomLogoSettingError(e));
  }
};
